import { AcceptedDayInput, day, diff, getOnlyDate } from '~/astra'

/** Calendar days `date` is before `relativeTo`, as Norwegian copy. Same day or later returns null. */
export function getDaysDifferenceText(date: AcceptedDayInput, relativeTo: AcceptedDayInput): string | null {
    const from = day(date)
    const to = day(relativeTo)

    const days = diff(getOnlyDate(to), getOnlyDate(from), 'day')

    const isBefore = days > 0
    // If single day difference, return singular form
    if (days === Math.abs(1)) {
        return `1 dag ${isBefore ? 'før' : 'etter'}`
    }
    // If multiple days difference, return plural form
    if (days > 1 || days < -1) {
        return `${Math.abs(days)} dager ${isBefore ? 'før' : 'etter'}`
    }
    // If days is 0, return null
    return null
}
